__turbopack_context__.v({
  "container": "Panel-module__LZR2lq__container",
  "headerContainer": "Panel-module__LZR2lq__headerContainer",
  "scrollableContainer": "Panel-module__LZR2lq__scrollableContainer",
  "scrollableContainerScroll": "Panel-module__LZR2lq__scrollableContainerScroll" + " " + "Panel-module__LZR2lq__scrollableContainer",
});
